import { render, staticRenderFns } from "./Disponibilidade8.vue?vue&type=template&id=4251d518&scoped=true&"
import script from "./Disponibilidade8.vue?vue&type=script&lang=js&"
export * from "./Disponibilidade8.vue?vue&type=script&lang=js&"
import style0 from "./Disponibilidade8.vue?vue&type=style&index=0&id=4251d518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4251d518",
  null
  
)

export default component.exports